<template>
  <a-card :bordered="false">
    <s-table size="default" :columns="columns" :data="loadData">
      <template slot="pic" slot-scope="text">
        <span class="pic"><img :src="text" /></span>
      </template>
    </s-table>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getBuydetail } from "@/api/purchase";

export default {
  name: "BuyDetail",
  components: {
    STable,
  },
  data() {
    return {
      mdl: [],
      columns: [
        {
          title: "图片",
          dataIndex: "pic_url",
          scopedSlots: { customRender: "pic" },
        },
        {
          title: "商品名称",
          dataIndex: "goods_name",
        },
        {
          title: "SKU",
          dataIndex: "sku",
        },
        {
          title: "单价",
          dataIndex: "unit_price",
        },
        {
          title: "兑换规则",
          dataIndex: "exchange_price",
        },
        {
          title: "订货数量",
          dataIndex: "quantity",
        },
        {
          title: "单价",
          dataIndex: "unit_price",
        },
      ],
      loadData: (params) => {
        return getBuydetail({ ...params, id: this.$route.params.id }).then(
          (res) => res
        );
      },
    };
  },
};
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
}
.pic > img {
  width: 50px;
  height: 50px;
  display: block;
}
</style>

